import { useEffect, useState } from 'react'

const SEARCHING_MESSAGES = [
  { icon: '🔍', text: 'Analyse de votre requête...' },
  { icon: '🧠', text: 'Identification des profils correspondants...' },
  { icon: '🌐', text: 'Exploration des bases de données...' },
  { icon: '📊', text: 'Scoring et classement des contacts...' },
  { icon: '📍', text: 'Filtrage par localisation...' },
  { icon: '✅', text: 'Finalisation des résultats...' },
]

export function SearchingAnimation({ query }) {
  const [msgIndex, setMsgIndex] = useState(0)
  const [dots, setDots] = useState('')

  useEffect(() => {
    const msgTimer = setInterval(() => {
      setMsgIndex((i) => (i + 1) % SEARCHING_MESSAGES.length)
    }, 2200)
    const dotsTimer = setInterval(() => {
      setDots((d) => (d.length >= 3 ? '' : d + '.'))
    }, 500)
    return () => {
      clearInterval(msgTimer)
      clearInterval(dotsTimer)
    }
  }, [])

  const current = SEARCHING_MESSAGES[msgIndex]

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '48px 24px', gap: 24 }}>
      <div style={{ position: 'relative', width: 72, height: 72 }}>
        <div style={{
          position: 'absolute', inset: 0, borderRadius: '50%',
          border: '3px solid rgba(91, 92, 244,0.1)',
          borderTop: '3px solid #5b5cf4',
          animation: 'spin 1s linear infinite',
        }} />
        <div style={{
          position: 'absolute', inset: 10, borderRadius: '50%',
          border: '2px solid rgba(91, 92, 244,0.05)',
          borderBottom: '2px solid rgba(91, 92, 244,0.4)',
          animation: 'spin 1.5s linear infinite reverse',
        }} />
        <div style={{
          position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 24,
        }}>
          {current.icon}
        </div>
      </div>

      {query && (
        <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.3)', fontStyle: 'italic', maxWidth: 320, textAlign: 'center' }}>
          « {query} »
        </div>
      )}

      <div style={{ fontSize: 14, color: 'rgba(255,255,255,0.65)', minHeight: 22, textAlign: 'center' }}>
        {current.text}{dots}
      </div>

      <div style={{ display: 'flex', gap: 6 }}>
        {SEARCHING_MESSAGES.map((_, i) => (
          <div
            key={i}
            style={{
              width: i === msgIndex ? 20 : 6,
              height: 6,
              borderRadius: 3,
              background: i === msgIndex ? '#5b5cf4' : 'rgba(255,255,255,0.1)',
              transition: 'all 0.3s ease',
            }}
          />
        ))}
      </div>
    </div>
  )
}

export default function LoadingAnimation({ targetNumber, query, onComplete }) {
  const [counter, setCounter] = useState(0)
  const [progress, setProgress] = useState(0)
  const [message, setMessage] = useState('Analyse en cours...')

  const messages = [
    'Analyse en cours...',
    'Recherche des profils...',
    'Calcul de pertinence...',
    'Finalisation...',
  ]

  useEffect(() => {
    // Animation duration based on target number (max 25s)
    const baseDuration = 2000
    const durationPerThousand = 200
    const randomFactor = 0.85 + Math.random() * 0.3
    const rawDuration = (baseDuration + (targetNumber / 1000) * durationPerThousand) * randomFactor
    const duration = Math.min(rawDuration, 25000)

    // Counter animation
    const counterSteps = Math.min(100, Math.max(50, Math.floor(duration / 40)))
    const counterIncrement = targetNumber / counterSteps
    const counterInterval = duration / counterSteps

    let currentCounter = 0
    const counterTimer = setInterval(() => {
      currentCounter += counterIncrement
      if (currentCounter >= targetNumber) {
        currentCounter = targetNumber
        clearInterval(counterTimer)
      }
      setCounter(Math.floor(currentCounter))
    }, counterInterval)

    // Progress bar animation
    const progressSteps = 100
    const progressInterval = duration / progressSteps

    let currentProgress = 0
    const progressTimer = setInterval(() => {
      currentProgress += 1
      setProgress(currentProgress)

      // Change message proportionally
      const newIndex = Math.floor(currentProgress / (100 / messages.length))
      if (newIndex < messages.length) {
        setMessage(messages[newIndex])
      }

      if (currentProgress >= 100) {
        clearInterval(progressTimer)
        setMessage('✓ Terminé !')
        setTimeout(() => {
          onComplete?.()
        }, 300)
      }
    }, progressInterval)

    return () => {
      clearInterval(counterTimer)
      clearInterval(progressTimer)
    }
  }, [targetNumber, onComplete])

  return (
    <div className="preview-inline-container">
      <div className="preview-counter-section">
        <div className="preview-counter-label">Prospects disponibles</div>
        <div className="preview-counter-number" style={{ transform: counter === targetNumber ? 'scale(1.1)' : 'scale(1)', transition: 'transform 0.2s' }}>
          {counter.toLocaleString()}
        </div>
        <div className="preview-query">"{query || 'Recherche...'}"</div>

        <div className="preview-loading-bar">
          <div className="preview-loading-fill" style={{ width: `${progress}%` }}></div>
        </div>
        <div className="preview-loading-text" style={{ color: progress === 100 ? '#5b5cf4' : 'inherit' }}>
          {message}
        </div>
      </div>
    </div>
  )
}
